export enum ClubRequestType {
  Invitation = 'invitation',
  Request = 'request',
}
